import { Grid } from '@mui/material';
import React from 'react';

function ListItemField( props ) {
    
    return <Grid item xs={props.size}>
        <p>{ props.data }</p>
    </Grid>
}
export default ListItemField;